export default __webpack_public_path__ + "static/class_1-87fad16afd754464b85976ee211063a6.png";